module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAYAAADhAJiYAAAAAXNSR0IArs4c6QAAASVJREFUWEft18EOQ0AQgOEhTn0UV9l4nOqTtX0c2ezVoziJNCMhKGZ2d1iHdaX1Z/pZ2wRudiQ364EYRP0icUJxQtQEqPNJURQfAHhSF150/otBDwDQAJBfdNO92zQAoIanrCzLvOs6jMK4EEebZZmq67qZHnulVNX3/TtETZqmL6010lmu1IE8fY0x1TiIxcIYwNPgxhjTbgZd7GlyM2ey+eq4wtPcDRmEF5zsaeGGG3TW+vTnhhV0kqdNN+wgvFDS054bqyBBT7tuXIJ8PR26sQ7y9ES6cQpy9cRx4xzk4InlxjeI64ntxiuI6cnKjXcQ5cnWjUjQgSdrN5JBa09ObsSCVp5g3Bf7bINF/krj+w4jxn1x8CCfgPVnRSYUgyQnQH3XD37OnQHqA6JeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fortune-wheel/decline.png
// module id = 3Uig
// module chunks = 215